import { useState, useRef, useContext } from "react";
import { Modal, NumberInput, Button, Text } from "@mantine/core";
import { AppContext } from "../AppContext";

const MintModal = () => {
  const { isOpen, toggleMintModal, lockPointer } = useContext(AppContext);
  const [value, setValue] = useState(1);
  const handlersRef = useRef(null);
  let price = 1;

  return (
    <Modal
      opened={isOpen}
      onClose={() => {
        toggleMintModal();
        lockPointer();
      }}
      title="Mint"
    >
      <Text size="md">Remaining supply: </Text>
      <div className="row flex">
        <Button onClick={() => handlersRef.current?.decrement()} variant="default">
          -
        </Button>
        <NumberInput
          data-autofocus
          handlersRef={handlersRef}
          value={value}
          onChange={setValue}
          min={1}
          max={100}
          defaultValue={1}
          hideControls
        />
        <Button onClick={() => handlersRef.current?.increment()} variant="default">
          +
        </Button>
        <Text size="md">Total: {(value * price).toFixed(3)} Ξ</Text>
      </div>
      <Button variant="filled">Mint</Button>
    </Modal>
  );
};

export default MintModal;
